import { render, staticRenderFns } from "./EditUserProfile.vue?vue&type=template&id=90afb1ec&scoped=true&"
import script from "./EditUserProfile.vue?vue&type=script&lang=ts&"
export * from "./EditUserProfile.vue?vue&type=script&lang=ts&"
import style0 from "./EditUserProfile.vue?vue&type=style&index=0&id=90afb1ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90afb1ec",
  null
  
)

export default component.exports